/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getFollowingUser.defs.js";
export { main as default } from "./getFollowingUser.defs.js";
